export class DeviationPictureFile {

    id = 0;
    deviationId = 0;
    displayName: string | null = null;
    fileName: string | null = null;

    constructor() {}
}